export class DualList {
  public selected: any[] = [];

  constructor() {}

  selectionManager(options: any[], selected: any[]) {
    this.selected = selected;

    selected.forEach((selection: Object) => {
      options.forEach((option: Object) => {
        if (option['key'] === selection['key']) {
          if (
            typeof option['data'] === 'object' &&
            typeof selection['data'] === 'object'
          ) {
            for (let selectionChild of selection['data']) {
              for (let optChild of option['data']) {
                if (optChild['key'] === selectionChild['key']) {
                  option['data'].splice(option['data'].indexOf(optChild), 1);

                  if (!option['data'].length) {
                    options.splice(options.indexOf(option), 1);
                  }
                }
              }
            }
          } else if (
            typeof option['data'] === 'string' &&
            typeof selection['data'] === 'string'
          ) {
            options.splice(options.indexOf(option), 1);
          }
        }
      });
    });
  }

  select(dataObj: any, options: any[]) {
    const filteredIndex: number = this.selected.findIndex(
      (obj: any) => obj.key === dataObj.key
    );

    options.splice(options.indexOf(dataObj), 1);

    if (filteredIndex !== -1) {
      this.selected[filteredIndex].data.push(...dataObj.data);
    } else {
      this.selected.push(dataObj);
    }

  }

  deselect(dataObj: any, options: any[]) {
    const filteredIndex: number = options.findIndex(
      (obj: any) => obj.key === dataObj.key
    );

    this.selected.splice(this.selected.indexOf(dataObj), 1);

    if (filteredIndex !== -1) {
      options[filteredIndex].data.push(...dataObj.data);
    } else {
      options.push(dataObj);
    }

    if (!this.selected.length) {
      localStorage.removeItem('options');
    }

  }

  selectGrouped(dataObj: any, ...args: any[]) {
    const [mainObj, options] = args;

    if (typeof mainObj.data === 'object') {
      if (this.selected.length) {
        const filteredIndex: number = this.selected.findIndex(
          (item) => item.key === mainObj.key
        );

        if (filteredIndex !== -1) {
          this.selected[filteredIndex].data.push(dataObj);
          this._groupRemover(dataObj, mainObj, options);
        } else {
          this._groupItemMover(dataObj, mainObj, options, this.selected);
        }
      } else {
        this._groupItemMover(dataObj, mainObj, options, this.selected);
      }

      // console.dir(this.selected);
    } else {
      throw new Error('Not an iterable');
    }

  }

  deselectGrouped(dataObj: any, ...args: any[]) {
    const [mainObj, options] = args;

    if (typeof mainObj.data === 'object') {
      if (options.length) {
        const filteredIndex: number = options.findIndex(
          (item: any) => item.key === mainObj.key
        );
  
        if (filteredIndex !== -1) {
          options[filteredIndex].data.push(dataObj);
          this._groupRemover(dataObj, mainObj, this.selected);
        } else {
          this._groupItemMover(dataObj, mainObj, this.selected, options);
        }
      } else {
        this._groupItemMover(dataObj, mainObj, this.selected, options);
      }

      // console.dir(this.selected);
    } else {
      throw new Error('Not an iterable');
    }

    if (!this.selected.length) {
      localStorage.removeItem('options');
    }

  }

  private _groupItemMover(
    dataObj: any,
    mainObj: any,
    main: any[],
    mainSelected: any[]
  ) {
    let clonedObj: any = { ...mainObj }; // Creating an copy of main Object.
    mainSelected.push(clonedObj); // Adding the copy of the main object to the selected Array.
    mainSelected.forEach((obj: any, index: number) => {
      if (obj.key === mainObj.key) {
        obj.data = []; // Clearing the selected instance of the mainObj
        obj.data.push(dataObj);
        mainObj.data.splice(mainObj.data.indexOf(dataObj), 1);

        if (!mainObj.data.length) this._groupRemover(obj, mainObj, main);
      }
    });
  }

  private _groupRemover(dataObj: any, mainObj: any, main: any[]) {
    mainObj.data.splice(mainObj.data.indexOf(dataObj), 1);

    if (!mainObj.data.length) {
      main.splice(main.indexOf(mainObj), 1);
    }
  }
}
